/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading components
 * -----------------------------------------------------------------------------------------------------------
 */
import auth from 'src/router/auth'
import Promotion from '../Promotion'
import NewPromotion from '../NewPromotion'
import EditPromotion from '../EditPromotion'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Define component
 * -----------------------------------------------------------------------------------------------------------
 */
export default [
  {
    path: '/promotions',
    name: 'promotion',
    component: Promotion,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/promotions/new',
    name: 'create-promotion',
    component: NewPromotion,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/promotions/edit/:id',
    name: 'edit-promotion',
    component: EditPromotion,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/promotion/routes/index.js